<template>
  <div class="invitation">
<!--    <van-nav-bar-->
<!--      :title="$t('m.syicon4')"-->
<!--      @click-left="onClickLeft"-->
<!--      left-arrow-->
<!--    ></van-nav-bar>-->
    <div class="dd-main">
      <div class="yqm">
        <div style="font-size: 20px">{{ $t("m.yq_span0") }}：</div>
        <div style=" font-size:26px;font-weight:bold;color:#FF3738;">
          {{ data.invite }}
        </div>
        <button type="button" class="copy" @click="copyText(data.invite)">
          复制
        </button>
      </div>
      <div class="ercode">
        <img
          style="width: 148px;margin:0 auto;display:block;"
          :src="qrCode"
          alt=""
        />
      </div>

      <div class="yqm1">
        <van-button
          :class="{ seled: type === 1 }"
          @click="tiaozhuan(1)"
          round="true"
          type="primary"
        >
          安卓下载
        </van-button>
        <div class="dd-div">
          <van-button
            :class="{ seled: type === 2 }"
            @click="tiaozhuan(2)"
            round="true"
            type="primary"
          >
            苹果下载一
          </van-button>
          <van-button
            :class="{ seled: type === 3 }"
            @click="tiaozhuan(3)"
            round="true"
            type="primary"
          >
            苹果下载二
          </van-button>
        </div>
        使用浏览器扫描二维码下载app
      </div>
      <div class="jjjs">
        <div class="jl1">
          <div class="jjjs-num">1</div>
          {{ $t("m.yq_span1") }} 10000*{{ data.l1 }}%=
          <span class="price">{{ 10000 * (data.l1 * 0.01) }}</span>
        </div>
        <div class="jl1">
          <div class="jjjs-num">2</div>
          {{ $t("m.yq_span2") }} 10000*{{ data.l2 }}%=
          <span class="price">{{ 10000 * (data.l2 * 0.01) }}</span>
        </div>
        <div class="jl1">
          <div class="jjjs-num">3</div>
          {{ $t("m.yq_span3") }} 10000*{{ data.l3 }}%=
          <span class="price">{{ 10000 * (data.l3 * 0.01) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getHyDataInfo } from "@api/user";

export default {
  data() {
    return {
      data: {},
      qrCode: "",
      type: 1
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    tiaozhuan(index) {
      this.data.qrCode = "";
      this.type = index;
      switch (index) {
        case 1:
          this.qrCode = this.data.app_android_url;
          break;
        case 2:
          this.qrCode = this.data.app_ios_url1;
          break;
        case 3:
          this.qrCode = this.data.app_ios_url2;
          break;
      }
    },
    getData() {
      getHyDataInfo().then(res => {
        this.data = res.data.data;
        console.log("-> this.data", this.data);
        this.qrCode = this.data.app_android_url;
      });
    },
    //复制文本
    copyText(text) {
      var element = this.createElement(text);
      element.select();
      element.setSelectionRange(0, element.value.length);
      document.execCommand("copy");
      element.remove();
      this.$toast.success("您成功复制了" + text);
    },
    //创建临时的输入框元素
    createElement(text) {
      var isRTL = document.documentElement.getAttribute("dir") === "rtl";
      var element = document.createElement("textarea");
      // 防止在ios中产生缩放效果
      element.style.fontSize = "12pt";
      // 重置盒模型
      element.style.border = "0";
      element.style.padding = "0";
      element.style.margin = "0";
      // 将元素移到屏幕外
      element.style.position = "absolute";
      element.style[isRTL ? "right" : "left"] = "-9999px";
      // 移动元素到页面底部
      let yPosition = window.pageYOffset || document.documentElement.scrollTop;
      element.style.top = `${yPosition}px`;
      //设置元素只读
      element.setAttribute("readonly", "");
      element.value = text;
      document.body.appendChild(element);
      return element;
    }
  }
};
</script>

<style lang="less">
.dd-main {
  width: 100%;
  height: 100vh;
  background: url("../../assets/images/img/img/yqpp.png") no-repeat;
  position: relative;
  background-size: 100% 100%;
}
.invitation {
  /* margin-top: -1rem; */
  width: 100%;
  height: 100vh;
  background-size: 100% 100%;
  position: relative;
  z-index: 999;
}

.jjjs {
  position: absolute;
  top: 77vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-weight: 700;

  .jl1 {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .jjjs-num {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    background: #ffcc49;
    color: #fff;
    padding: 5px 8px;
    margin-right: 15px;
    font-size: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}

.seled {
  background-color: #dadada !important;
}
.price {
  margin: 0 5px;
  font-size: 18px;
  color: red;
}

.yqm {
  color: #666;
  position: absolute;
  top: 20vh;
  width: 100%;
  text-align: center;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .copy {
    border-radius: 20px;
    margin-left: 5px;
    padding: 2px 8px;
    color: #ffc107;
    font-size: 12px;
    vertical-align: middle;
    border: 2px solid #ffc107;
  }
}

.yqm1 {
  position: absolute;
  font-size: 16px;
  top: 50vh;
  width: calc(100% - 0rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem;
  color: #ffffff;

  .dd-div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button {
      width: 48%;
    }
  }

  button {
    width: 100%;
    margin-bottom: 10px;
  }
}

.yqm1 button {
  font-size: 16px;
  font-weight: bold;
  background: #ffcc49;
  height: 45px;
  color: #ffffff;
  border: 0px solid;
}

.ercode {
  width: 100%;
  height: 148px;
  position: absolute;
  top: 25vh;
  /* bottom: 100px; */
}

.ercode img {
  width: 100%;
  height: 100%;
}
</style>
